export const tables = (state) => state.tables

export const nativeTables = (state) => state.tables.filter(x => {
    let mergeTables = []
    state.tables.forEach(tab => {
        if(tab.table_id){
            mergeTables.push(tab.table_id)
        }
    })
    return !mergeTables.includes(x.id)
})
export const getRoomTables = (state) => (id) => state.tables.filter(x => x.room_id === id) || []
export const getTableOrders = (state) => (id) => state.tables.find(x => x.id === id)?.orders || []
export const getRealTables = (state) => (id) => state.tables.filter(x => x.room_id === id && !x.table_id) || []
